import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AppConfig, APP_CONFIG_TOKEN } from "libs/config/app.lib.config";
import { Observable } from 'rxjs';

@Injectable({
	providedIn: "root",
})
export class MediaBaseService {
	private httpClient = inject(HttpClient);
	private config = inject<AppConfig>(APP_CONFIG_TOKEN);

	getFile(mediaId: string): Observable<any> {
		return this.httpClient.get(`${this.config.apiUrl}/media/${mediaId}`, { withCredentials: true });
	}
}
